// v5.3.0 · Presupuesto de resolución de video (Agora cobra por la resolución SUMADA de todos los videos que cada persona recibe).
// Tope: HD = 921 600 px sumados (1280×720). Si se supera, la persona pasa a «Full HD» y cada minuto cuenta ×9 en vez de ×4.
export const HD_BUDGET = 921600;
export const SCREEN_PROFILE = { width: 960, height: 540, frameRate: 15, bitrateMin: 200, bitrateMax: 900 }; // 518 400 px
export const SCREEN_PIXELS = SCREEN_PROFILE.width * SCREEN_PROFILE.height;

const PRESETS = [
  { width: 1280, height: 720, frameRate: 24, bitrateMax: 1130 },
  { width: 960, height: 540, frameRate: 24, bitrateMax: 800 },
  { width: 854, height: 480, frameRate: 24, bitrateMax: 700 },
  { width: 640, height: 360, frameRate: 20, bitrateMax: 500 },
  { width: 480, height: 270, frameRate: 15, bitrateMax: 300 },
  { width: 320, height: 180, frameRate: 15, bitrateMax: 180 },
  { width: 160, height: 90, frameRate: 10, bitrateMax: 60 },
];

/** Mayor resolución de cámara tal que (n videos recibidos × píxeles) ≤ presupuesto. */
export function cameraProfile(nStreams = 1, budget = HD_BUDGET) {
  const n = Math.max(1, nStreams);
  return PRESETS.find((p) => p.width * p.height * n <= budget) || PRESETS[PRESETS.length - 1];
}

/** Clave estable del perfil (para no reconfigurar el codificador sin necesidad). */
export const profileKey = (p) => `${p.width}x${p.height}`;
